import * as _xtend2 from "xtend";

var _xtend = "default" in _xtend2 ? _xtend2.default : _xtend2;

import * as _fusspot2 from "@mapbox/fusspot";

var _fusspot = "default" in _fusspot2 ? _fusspot2.default : _fusspot2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var xtend = _xtend;
var v = _fusspot;

function file(value) {
  // If we're in a browser so Blob is available, the file must be that.
  // In Node, however, it could be a filepath or a pipeable (Readable) stream.
  if (typeof window !== "undefined") {
    if (value instanceof _global.Blob || value instanceof _global.ArrayBuffer) {
      return;
    }

    return "Blob or ArrayBuffer";
  }

  if (typeof value === "string" || value.pipe !== undefined) {
    return;
  }

  return "Filename or Readable stream";
}

function assertShape(validatorObj, apiName) {
  return v.assert(v.strictShape(validatorObj), apiName);
}

function date(value) {
  var msg = "date";

  if (typeof value === "boolean") {
    return msg;
  }

  try {
    var date = new Date(value);

    if (date.getTime && isNaN(date.getTime())) {
      return msg;
    }
  } catch (e) {
    return msg;
  }
}

function coordinates(value) {
  return v.tuple(v.number, v.number)(value);
}

exports = xtend(v, {
  file: file,
  date: date,
  coordinates: coordinates,
  assertShape: assertShape
});
export default exports;